import { accessPermissions, authorizationRoles } from "@brainics/shared";
import { z } from "zod";

export const authorizationRoleSchema = z.enum(authorizationRoles);
export const assignableAuthorizationRoleSchema = authorizationRoleSchema.exclude(["guest"]);
export const accessPermissionSchema = z.enum(accessPermissions);

export const accessSnapshotSchema = z.object({
  roles: z.array(assignableAuthorizationRoleSchema),
  permissions: z.array(accessPermissionSchema),
});

export type AccessSnapshot = z.infer<typeof accessSnapshotSchema>;
